import { useCallback } from 'react';

import {
  MetadataConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

const useConnectionFailed = () => {
  const { handleUpdateMetadataConnectionModalScreen } = useSFConnectionState();

  const handleGoBack = useCallback(() => {
    handleUpdateMetadataConnectionModalScreen(
      MetadataConnectionModalScreens.CONNECTION_CREATE_SCREEN,
    );
  }, [handleUpdateMetadataConnectionModalScreen]);

  return {
    handleGoBack,
  };
};

export { useConnectionFailed };
